export default "__VITE_ASSET__BnwtfMqn__"